import './BackButton.scoped.scss'

export default function BackButton({ url = null }) {
  return url ? <a className="back" href={url}></a>
    : <a className="back" onClick={() => window.history.back()}></a>
}

